import classnames from 'classnames/bind'
import { useAppSelector } from '@/redux/hooks'
import { useRouter } from 'next/router'
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'
// Components
import Icon from '@/assets/icons'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// PropTypes
type propTypes = {
  title: string
  onClick?: () => void
  staticLink?: string
  className?: string
}

const GoBackNavi = (props: propTypes) => {
  const { title, onClick, className, staticLink } = props
  const previousPage = useAppSelector((state) => state.common.previousPage)
  const router = useRouter()
  return (
    <div
      onClick={() => {
        if (onClick) {
          onClick()
          return
        } else if (!previousPage && staticLink) {
          handleRoutePushWithQuery({ router, pathname: staticLink })
        } else {
          router.back()
        }
      }}
      className={cx('go-back-navi', className)}
    >
      <div className={cx('go-back-navi-icon')}>
        <Icon.ArrowLeft />
      </div>
      <div className={cx('go-back-navi-text')}>{title}</div>
    </div>
  )
}

export default GoBackNavi
